import { useContext, useEffect, useState } from "react";
import TableContext from "../tableContext";
import { moment } from "@LIBS";
import cloneDeep from "lodash/cloneDeep";

const dateMathcOperator = (val, selectedVal, operator) => {
  if (operator === "equal") {
    return val.isSame(selectedVal);
  } else if (operator === "bigger") {
    return val.isSameOrAfter(selectedVal);
  } else if (operator === "smaller") {
    return val.isSameOrBefore(selectedVal);
  }
};

const isMatch = (
  searchValues,
  selectedValueType,
  selectedKey,
  selectedValue,
  operator
) => {
  if (selectedValueType === "date") {
    return searchValues.some(
      (x) =>
        x.labelStr === selectedKey &&
        dateMathcOperator(x.valueStr, selectedValue, operator)
    );
  } else {
    if (operator === "equal") {
      return searchValues.some(
        (x) => x.labelStr === selectedKey && x.valueStr === selectedValue
      );
    } else if (operator === "bigger") {
      return searchValues.some(
        (x) => x.labelStr === selectedKey && x.valueStr > selectedValue
      );
    } else if (operator === "smaller") {
      return searchValues.some(
        (x) => x.labelStr === selectedKey && x.valueStr < selectedValue
      );
    } else {
      console.error("isMatch hatası!");
      return false;
    }
  }
};

const useSearch = () => {
  const { dataSource, searchSelectedValues } = useContext(TableContext);
  const [state, setState] = useState(dataSource);

  useEffect(() => {
    if (searchSelectedValues && searchSelectedValues.length > 0) {
      let arr = cloneDeep(dataSource);
      searchSelectedValues.forEach((item) => {
        const vals = item.split(/[<>:=\n]/g).map((x) => x.trim());
        const selectedKey = vals[0];
        let selectedValue = vals[1];
        let selectedValueType = "string";
        if (!isNaN(selectedValue)) {
          selectedValueType = "number";
          selectedValue = parseFloat(vals[1]);
        } else if (moment(selectedValue, true).isValid()) {
          selectedValueType = "date";
          selectedValue = moment(vals[1]);
        }

        if (item.includes(":") || item.includes("=")) {
          arr = arr.filter((x) =>
            isMatch(
              x.searchValues,
              selectedValueType,
              selectedKey,
              selectedValue,
              "equal"
            )
          );
        } else if (item.includes(">")) {
          arr = arr.filter((x) =>
            isMatch(
              x.searchValues,
              selectedValueType,
              selectedKey,
              selectedValue,
              "bigger"
            )
          );
        } else if (item.includes("<")) {
          arr = arr.filter((x) =>
            isMatch(
              x.searchValues,
              selectedValueType,
              selectedKey,
              selectedValue,
              "smaller"
            )
          );
        }
      });
      setState(arr);
    } else {
      setState(dataSource);
    }
  }, [searchSelectedValues, dataSource]);

  return state;
};

export default useSearch;
